import { getFiltersByLocalStorageKey } from '../../Utilities/FilterUtilities'

const initialState = {
  activeCategory: null,
  error: false,
  errorDetails: {
    message: null,
    code: null,
  },
  filters: getFiltersByLocalStorageKey('MY_RECEIPTS_FILTERS'),
  lastRequestId: null,
  loading: false,
  receiptDetailsLoading: false,
  results: null,
  resultsMode: 'table',
  selected: {},
  selectedReceipt: null,
  selectedOwnershipReceipts: [],
  selectedReceiptHasOwners: null,
  showSelected: false,
  templates: {},
  userOwnsSelectedReceipt: null,
  myReceiptDetails: [],
  myReceiptDetailError: false,
  myReceiptDetailErrorMessage: {
    message: null,
    code: null,
  },
}
const MyReceiptsReducer = (state = initialState, action) => {
  switch (action.type) {
    case '@@mrcpt/RESET_STATE':
      return initialState
    case '@@mrcpt/INVALIDATE_CACHE':
      return {
        ...state,
        results: null,
        selected: {},
        selectedReceipt: null,
        showSelected: false,
      }
    case '@@mrcpt/SET_ACTIVE_CATEGORY':
      return {
        ...state,
        activeCategory: action.category,
      }
    case 'SET_MY_RECEIPTS':
      return {
        ...state,
        rows: action.rows,
        template: action.template,
      }
    case 'SELECT_MY_RECEIPTS_ROW':
      return {
        ...state,
        selected: {
          ...state.selected,
          [action.category]: action.selected,
        },
        selectedReceipt: action.row,
        showSelected:
          state.selected[action.category] !== action.selected && action.selected !== null
            ? true
            : !state.showSelected,
      }
    case 'SELECT_MY_RECEIPT_RECORD':
      return { ...state, selected: action.selected }
    case 'SET_MY_RECEIPTS_RESULTS_MODE':
      return { ...state, resultsMode: action.mode }
    case 'SET_MY_RECEIPTS_SELECTED_OWNERSHIP_RECEIPTS':
      return {
        ...state,
        selectedOwnershipReceipts: action.selectedOwnershipReceipts,
      }
    case 'SET_RECEIPT_DETAILS_LOADING':
      return { ...state, receiptDetailsLoading: action.loading }
    case 'SET_USER_OWNS_SELECTED_RECEIPT':
      return { ...state, userOwnsSelectedReceipt: action.isOwner }
    case 'SET_SELECTED_RECEIPT_HAS_OWNERS':
      return { ...state, selectedReceiptHasOwners: action.hasOwners }
    case '@@mrcpt/SET_FILTERS':
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.category]: action.filters,
        },
      }
    case 'SET_MY_RECEIPTS_LOADING':
      return {
        ...state,
        loading: action.loading,
      }
    case 'SET_MY_RECEIPT_DETAIL_LOADING':
      return {
        ...state,
        myReceiptDetailsLoading: action.loading,
      }
    case 'SET_MY_RECEIPTS_ERROR':
      return {
        ...state,
        error: action.error,
      }
    case 'SET_MY_RECEIPTS_ERROR_DETAILS':
      return {
        ...state,
        errorDetails: action.errorDetails,
      }
    case '@@mrcpt/SET_REQUEST_ID':
      return { ...state, lastRequestId: action.requestId }
    case 'SET_MY_RECEIPT_DETAILS':
      return {
        ...state,
        myReceiptDetails: action.details,
      }
    case 'SET_MY_RECEIPT_DETAIL_ERROR':
      return {
        ...state,
        myReceiptDetailError: action.error,
      }
    case 'SET_MY_RECEIPT_DETAIL_ERROR_MESSAGE':
      return {
        ...state,
        myReceiptDetailErrorMessage: action.errorDetail,
      }
    default:
      return state
  }
}

export default MyReceiptsReducer



// WEBPACK FOOTER //
// ./src/components/MyReceipts/MyReceiptsReducer.js